<template>
    <ul v-if="channels.length"
        class="flex items-center mb-16">
        <li v-for="channel in channels"
            :key="channel.type"
            :data-popup="(channel.type == 'video') ? 'video' : null"
            class="mx-4">
            <social-button
                :platform="channel.type"
                :url="(channel.type == 'email') ? 'mailto:' + channel.value : channel.value"
                :class="(channel.type == 'video') ? 'trigger' : null">
            </social-button>
            <div v-if="channel.type == 'video'" class="hidden">
                <div class="w-400 md:w-768">
                    <play-video :url="embedVideo(channel.value)"></play-video>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import PlayVideo from './PlayVideo.vue';
import SocialButton from './SocialButton.vue';
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { videoPlayer } from '../../../app/mixins/videoPlayer';

export default {
    components: {
        'play-video': PlayVideo,
        'social-button': SocialButton,
    },
    mixins: [videoPlayer()],
    props: {
        member: {
            required: true,
        }
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        channels ()
        {
            let fields = [
                    { type: 'email', field: 'email' },
                    { type: 'facebook', field: 'social_facebook' },
                    { type: 'instagram', field: 'social_instagram' },
                    { type: 'linkedin', field: 'social_linkedin' },
                    { type: 'twitter', field: 'social_twitter' },
                ],
                channels = []
                ;

            // first try to add the video
            let video = this.getVideoUrl();
            if (video !== null) {
                channels.push({ type: 'video', value: video });
            }

            // now add all other fields
            fields.forEach(field => {
                if (
                    this.member.hasOwnProperty(field.field) &&
                    (this.member[field.field] != '') &&
                    (this.member[field.field] !== null)
                ) {
                    field.value = this.member[field.field];

                    channels.push(field);
                }
            });

            return channels;
        }
    },
    methods: {
        getVideoUrl () {
            if (this.member.translated_video_url.hasOwnProperty(this.locale) &&
                this.validateVideo(this.member.translated_video_url[this.locale]))  {
                return this.member.translated_video_url[this.locale];
            } else if (this.validateVideo(this.member.video_url)) {
                return this.member.video_url;
            }

            return null;
        },
    },
}
</script>
